import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "@hotwired/turbo-rails";

Rails.start();
Turbolinks.start();
ActiveStorage.start();
require("@rails/actiontext");




import "controllers";
import "@oddcamp/cocoon-vanilla-js";
import "chartkick/chart.js"

window.dispatchMapsEvent = function (...args) {
  const event = document.createEvent("Events");
  event.initEvent("google-maps-callback", true, true);
  event.args = args;
  window.dispatchEvent(event);
};

